import { useColorMode } from "@chakra-ui/react";

export default function withColorMode(Component) {
  function ComponentWithColorMode(props) {
    const { colorMode } = useColorMode();
    return <Component colorMode={colorMode} {...props} />;
  }
  return ComponentWithColorMode;
}
